import React from 'react';
import { Tooltip, TooltipProvider, TooltipTrigger, TooltipContent, } from '@cargomatic/ui';
export function TruncatedCell({ text, maxWidth = 'max-w-48', }) {
    if (!text)
        return null;
    return (React.createElement(TooltipProvider, null,
        React.createElement(Tooltip, null,
            React.createElement(TooltipTrigger, { asChild: true },
                React.createElement("span", { className: `block ${maxWidth} truncate` }, text)),
            React.createElement(TooltipContent, null, text))));
}
